import useVuelidate, { GlobalConfig } from '@vuelidate/core'
import { computed, reactive, Ref, watch } from 'vue'

interface Indexable {
  [key: string]: any
}

export default (rules: Indexable, state: Ref, config?: GlobalConfig) => {
  const $v: Indexable = useVuelidate(rules, state, config)
  const isFormValid = computed<boolean>(() => !$v.value.$invalid)
  const formErrors: Indexable = reactive({})

  function getErrors(fieldName: string) {
    if ($v.value[fieldName]?.$dirty) {
      const validators = Object.keys(rules.value[fieldName])

      const errorsForValidator = validators
        .map((validatorName) => {
          const validator = $v.value[fieldName][validatorName]
          const isValidatorFailed = validator.$invalid
          const isPending = validator.$pending

          if (isValidatorFailed && !isPending) {
            return validator.$message
          }
        })
        .filter((el) => el)

      return errorsForValidator
    }

    return []
  }

  function updateFormErrors() {
    const stateFields = Object.keys(state.value)

    stateFields.forEach((fieldName) => {
      formErrors[fieldName] = getErrors(fieldName)[0] || ''
    })
  }

  function setServerErrors(errors: Indexable) {
    const errorFields = Object.entries(errors)

    errorFields.forEach(([fieldName, messages]) => {
      formErrors[fieldName] = messages[0] || ''
    })
  }

  function touchField(fieldName: string, delay = 0) {
    $v.value[fieldName]?.$touch()

    setTimeout(() => updateFormErrors(), delay)
  }

  function touchAll() {
    $v.value?.$touch()

    updateFormErrors()
  }

  function resetValidation() {
    $v.value.$reset()
  }

  watch(state, () => updateFormErrors(), { deep: true })

  return {
    $v,
    formErrors,
    isFormValid,
    touchField,
    touchAll,
    setServerErrors,
    resetValidation,
  }
}
